import { FC } from 'react';
import { Box } from '@mui/material';
import { Control, Controller, FieldErrors, UseFormSetValue, UseFormTrigger } from 'react-hook-form';
import { DatePicker } from '@mui/x-date-pickers';
import { FormData } from '../constants';
import dayjs from 'dayjs';

type Props = {
	formWatch: FormData;
	control: Control<FormData>;
	errors: FieldErrors<FormData>;
	trigger: UseFormTrigger<FormData>;
	setValue: UseFormSetValue<FormData>;
};

const CalendarInputs: FC<Props> = ({ formWatch, control, errors, trigger, setValue }) => {
	return (
		<>
			{formWatch.recurrenceType === 'SINGLE' ? (
				<Box>
					<Controller
						name="startDate"
						control={control}
						render={({ field: { onChange, value }, formState: { errors } }) => (
							<DatePicker
								name="startDate"
								label="Start Date"
								value={value ? dayjs(value) : null}
								onChange={(value) => {
									onChange(value ? dayjs(value)!.format() : null);
									trigger('startDate');
								}}
								sx={{ marginBottom: '1rem', width: '100%' }}
								slotProps={{
									textField: {
										fullWidth: true,
										error: !!errors.startDate,
										helperText: errors.startDate?.message,
										slotProps: {
											inputLabel: { shrink: true },
										},
									},
								}}
							/>
						)}
					/>
					<Controller
						name="endDate"
						control={control}
						render={({ field: { onChange, value }, formState: { errors } }) => (
							<DatePicker
								name="endDate"
								label="End Date"
								value={value ? dayjs(value) : null}
								onChange={(value) => {
									onChange(value ? dayjs(value)!.format() : null);
									trigger('endDate');
								}}
								sx={{ marginBottom: '1rem', width: '100%' }}
								slotProps={{
									textField: {
										fullWidth: true,
										error: !!errors.endDate,
										helperText: errors.endDate?.message,
										slotProps: {
											inputLabel: { shrink: true },
										},
									},
								}}
							/>
						)}
					/>
				</Box>
			) : (
				''
			)}
		</>
	);
};

export default CalendarInputs;
